import {Button} from '@wandb/weave/components/Button';
import React, {useState} from 'react';

import {useMediaSettingsDrawerContext} from './MediaSettingsDrawerContextProvider';
import {MediaSettingsSection} from './types';
export const MediaSettingsDrawerSection = ({
  title,
  settings,
}: MediaSettingsSection) => {
  const [isOpen, setIsOpen] = useState(true);
  const {config} = useMediaSettingsDrawerContext();
  return (
    <div className="flex flex-col pt-16 first:pt-0">
      <div className="flex">
        <Button
          data-test={`media-settings-drawer-section-toggle-${title}`}
          icon={isOpen ? 'chevron-down' : 'chevron-next'}
          onClick={() => setIsOpen(!isOpen)}
          variant="ghost"
        />
        <div className="text-xl font-semibold">{title}</div>
      </div>
      {isOpen && (
        <div
          className="pl-[32px] pt-8"
          data-test={`media-settings-drawer-section-${title}`}>
          {settings.map(
            ({component: SettingComponent, getComponentKey}, index) => (
              <div
                key={`${title}-${index}-${getComponentKey?.(config) ?? ''}`}
                className="pt-16 first:pt-0">
                <SettingComponent />
              </div>
            )
          )}
        </div>
      )}
    </div>
  );
};
